type Prop = {
    map: google.maps.Map;
    body: string;
    position: google.maps.ControlPosition;
    action: () => void;
    title?: string;
}

type PropInput = {
    map: google.maps.Map;
    position: google.maps.ControlPosition;
    placeholder: string;
    change?: (element: HTMLInputElement, text: string) => void;
    title?: string;
}

export function createButtonMap(prop: Prop){
    const  { body, map, position, action, title } = prop;

    // Crear el div del botón
    const buttonDiv = document.createElement('div');

    // Aplicar las clases de Google Maps
    buttonDiv.className = 'gm-style-mtc';
    buttonDiv.style.backgroundColor = 'white';
    buttonDiv.style.border = '2px solid #fff';
    buttonDiv.style.borderRadius = '2px';
    buttonDiv.style.boxShadow = '0 1px 3px rgba(0,0,0,.3)';
    buttonDiv.style.cursor = 'pointer';
    buttonDiv.style.marginBottom = '22px';
    buttonDiv.style.marginTop = '5px';
    buttonDiv.style.textAlign = 'center';
    buttonDiv.title = title || '';

    // Crear el contenido del botón
    const buttonText = document.createElement('div');
    buttonText.style.color = 'rgb(25,25,25)';
    buttonText.style.fontFamily = 'Roboto,Arial,sans-serif';
    buttonText.style.fontSize = '12px';
    buttonText.style.lineHeight = '0';
    buttonText.style.padding = '5.5px';
    buttonText.innerHTML = body;

    // Añadir el texto al botón
    buttonDiv.appendChild(buttonText);

    // Añadir un evento de clic al botón
    buttonDiv.addEventListener('click', () => action());

    // Añadir el botón al mapa
    map.controls[position].push(buttonDiv);
}

export function createInputMap(prop: PropInput): HTMLInputElement{
    const  { map, position , placeholder} = prop;

    // Crear el div del botón
    const inputElement = document.createElement('input');

    // Aplicar las clases de Google Maps
    inputElement.className = 'gm-style-mtc';
    inputElement.setAttribute('placeholder', placeholder);
    inputElement.style.backgroundColor = 'white';
    inputElement.style.border = '2px solid #fff';
    inputElement.style.borderRadius = '2px';
    inputElement.style.boxShadow = '0 1px 3px rgba(0,0,0,.3)';
    inputElement.style.cursor = 'pointer';
    inputElement.style.marginBottom = '22px';
    inputElement.style.marginTop = '5px';
    inputElement.style.padding = '3.5px';

    // Crear el contenido del botón
    const buttonText = document.createElement('div');
    buttonText.style.color = 'rgb(25,25,25)';
    buttonText.style.fontFamily = 'Roboto,Arial,sans-serif';
    buttonText.style.fontSize = '12px';
    buttonText.style.lineHeight = '0';
    buttonText.style.padding = '5.5px';

    // Añadir el texto al botón
    inputElement.appendChild(buttonText);

    // Añadir un evento de clic al botón

    // Añadir el botón al mapa
    map.controls[position].push(inputElement);

    return inputElement;
}
